import { percentile } from './computeSummaryStats';

/** Ports the workbook's "SELL vs MIN OTA" CF (E27:E590): red/white/green anchored at {min, 50th percentile, max}. */
export interface SellVsMinOtaRange {
  min: number;
  mid: number;
  max: number;
}

const RED = { r: 0xf8, g: 0x69, b: 0x6b };
const WHITE = { r: 0xfc, g: 0xfc, b: 0xff };
const GREEN = { r: 0x63, g: 0xbe, b: 0x7b };

function lerpChannel(from: number, to: number, t: number): number {
  return Math.round(from + (to - from) * t);
}

export function computeSellVsMinOtaRange(values: ReadonlyArray<number>): SellVsMinOtaRange | null {
  if (values.length === 0) {
    return null;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  if (max <= min) {
    return null;
  }
  const mid = percentile(values, 0.5) ?? (min + max) / 2;
  return { min, mid, max };
}

export function computeSellVsMinOtaColor(value: number, range: SellVsMinOtaRange): { bgcolor: string; color: string } {
  const { min, mid, max } = range;
  let r = WHITE.r;
  let g = WHITE.g;
  let b = WHITE.b;

  if (mid > min && value <= mid) {
    const t = Math.min(1, Math.max(0, (value - min) / (mid - min)));
    r = lerpChannel(RED.r, WHITE.r, t);
    g = lerpChannel(RED.g, WHITE.g, t);
    b = lerpChannel(RED.b, WHITE.b, t);
  } else if (max > mid && value > mid) {
    const t = Math.min(1, Math.max(0, (value - mid) / (max - mid)));
    r = lerpChannel(WHITE.r, GREEN.r, t);
    g = lerpChannel(WHITE.g, GREEN.g, t);
    b = lerpChannel(WHITE.b, GREEN.b, t);
  }

  // Fixed dark text — the workbook's colorScale rule only ever sets fill, never font color.
  return { bgcolor: `rgb(${r}, ${g}, ${b})`, color: '#1a1916' };
}
